import {useEffect,useState, useRef} from 'react'
import axios from 'axios'
//import { useNavigate } from 'react-router-dom'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from '../components/ViewModalHeader'
import { getRequestCTXID } from '../request/request'
import { KTSVG } from '../../../../../_metronic/helpers'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import { useAuth } from '../../../auth'
import Swal from 'sweetalert2'
import { useAppSelector } from '../../../../../redux/hooks'

interface Paso2Type {
  listEdgeOutbund: Record<string, unknown>;
  listInterOutbund: Record<string, unknown>;
  listIntraOutbund: Record<string, unknown>;
  llistVpnOutbund: Record<string, unknown>;
  total: string;
}

const API_URL = process.env.REACT_APP_API_URL



const ViewModalNewCTX = ( props:any ) => {
  /***************************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)

  const{currentUser}= useAuth()

  const [ReqId,setReqId]= useState({
    data:{
      paso1:{   
        cloud:'',
        Throughput:'',
        continente:'',
        region:'',
        tipo_locacion:'',
        type_ctx:'',
        listVPNcon:[{
          total: '', 
          Cantidad: '', 
          Connectcap: ''
        }],
        listCloudConnIntra:[{
          RegionIntra: '',
          availability: '',
          ConexionIntra: '',
          CapacidadIntra: ''
        }],
        listCloudConnInter:[{
          ZonaInter: '', LocacionInter: '', ConexionInterReg: '', CapacidadInterReg: '', ContinenteInterreg:''
        }],
        listCEdgeConn:[{
          totaledge: '', 
          opcionEdge: '', 
          cantidadedge: '', 
          capacidadedge: ''
        }],
        listVRF:[{VRF_name:''}],
        Security: []

         },
      paso2:{
        listEdgeOutbund:{},
        listInterOutbund:{},
        listIntraOutbund:{},
        llistVpnOutbund:{},
        total:'' 
       }
     }
  })
   
  /***************************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    console.log(props.id)
    //colocar llamada al ep de ticket for id 
    const fetchData = async () => {
      try {
        if( props.id !== "" ){
        const Suscripcion = await getRequestCTXID(props.id);
        setReqId(Suscripcion.data);
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
  
      fetchData();

  }, [props.id])
  /************************************************** */




  const tbody = document.getElementById('tabla-body');

if (tbody) {
  // El elemento 'tbody' existe, puedes trabajar con él de manera segura
  for (const key in ReqId.data.paso2.llistVpnOutbund) {
    if (ReqId.data.paso2.llistVpnOutbund.hasOwnProperty(key)) {
      const row = document.createElement('tr');
      const nameCell = document.createElement('td');
      nameCell.textContent = key;
      const valueCell = document.createElement('td');
      valueCell.textContent = ReqId.data.paso2.llistVpnOutbund[key as keyof typeof ReqId.data.paso2.llistVpnOutbund]

      row.appendChild(nameCell);
      row.appendChild(valueCell);

      tbody.appendChild(row);
    }
  }
} else {
  // El elemento 'tbody' no existe, maneja esta situación como desees
  console.log("El elemento 'tbody' no se encontró.");
}

if (tbody) {
  // El elemento 'tbody' existe, puedes trabajar con él de manera segura
  for (const key in ReqId.data.paso2.listIntraOutbund) {
    if (ReqId.data.paso2.listIntraOutbund.hasOwnProperty(key)) {
      const row = document.createElement('tr');
      const nameCell = document.createElement('td');
      nameCell.textContent = key;
      const valueCell = document.createElement('td');
      valueCell.textContent = ReqId.data.paso2.listIntraOutbund[key as keyof typeof ReqId.data.paso2.listIntraOutbund]

      row.appendChild(nameCell);
      row.appendChild(valueCell);

      tbody.appendChild(row);
    }
  }
} else {
  // El elemento 'tbody' no existe, maneja esta situación como desees
  console.log("El elemento 'tbody' no se encontró.");
}

if (tbody) {
  // El elemento 'tbody' existe, puedes trabajar con él de manera segura
  for (const key in ReqId.data.paso2.listInterOutbund) {
    if (ReqId.data.paso2.listInterOutbund.hasOwnProperty(key)) {
      const row = document.createElement('tr');
      const nameCell = document.createElement('td');
      nameCell.textContent = key;
      const valueCell = document.createElement('td');
      valueCell.textContent = ReqId.data.paso2.listInterOutbund[key as keyof typeof ReqId.data.paso2.listInterOutbund]

      row.appendChild(nameCell);
      row.appendChild(valueCell);

      tbody.appendChild(row);
    }
  }
} else {
  // El elemento 'tbody' no existe, maneja esta situación como desees
  console.log("El elemento 'tbody' no se encontró.");
}



if (tbody) {
  // El elemento 'tbody' existe, puedes trabajar con él de manera segura
  for (const key in ReqId.data.paso2.listEdgeOutbund) {
    if (ReqId.data.paso2.listEdgeOutbund.hasOwnProperty(key)) {
      const row = document.createElement('tr');
      const nameCell = document.createElement('td');
      nameCell.textContent = key;
      const valueCell = document.createElement('td');
      valueCell.textContent = ReqId.data.paso2.listEdgeOutbund[key as keyof typeof ReqId.data.paso2.listEdgeOutbund]

      row.appendChild(nameCell);
      row.appendChild(valueCell);

      tbody.appendChild(row);
    }
  }
} else {
  // El elemento 'tbody' no existe, maneja esta situación como desees
  console.log("El elemento 'tbody' no se encontró.");
}

  return (
    <>
      
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y  mx-5 mx-xl-15 my-7'>
            <Card4
                  icon='/media/svg/files/NubeTD.svg'
                  title=' '
                  description=''></Card4>
                  <div className='text-center mb-5'>
                  <h1 className='text-dark fw-bolder mb-3'>CTX Request</h1>
                  </div>

              <div className='text-center mb-5'>
                <h1 className='text-dark fw-bolder mb-3'>Request No. {props.id}</h1>
              </div>
              <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                {/* begin::Heading */}
                
                {/* begin::Heading */}
                {/********************************************************************************** */}

              <div className="card-body card-scroll h-350px ">
                  <div className='bg-light-info p-8 rounded text-center'>
                    <div >
                      <p> <strong className='text-info'> Cloud:</strong>  {ReqId.data.paso1.cloud}</p>
                      <p> <strong className='text-info'> Location type:</strong> {ReqId.data.paso1.tipo_locacion}</p>
                      <p> <strong className='text-info'> Continent:</strong> {ReqId.data.paso1.continente}</p>
                      <p> <strong className='text-info'> Region:</strong> {ReqId.data.paso1.region}</p>
                      <p> <strong className='text-info'> CTX Type:</strong> {ReqId.data.paso1.type_ctx}</p>
                      <p> <strong className='text-info'> Plan: </strong> {ReqId.data.paso1.Throughput}</p>

                    </div>
                  </div>
                  <br />
                 {/* begin::Table 1 */}
                 {ReqId.data.paso1.listVPNcon.length !== 0 &&
                  <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VPN Connectors</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                      <th>Quantity</th>
                                      <th>Connector Size </th>                               
                                      <th>Total</th>
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {ReqId.data.paso1.listVPNcon.map((d:any,i:any)=>(
                                          <tr key={i}>
                                         
                                            <td>{d.Cantidad}</td>
                                            <td>{d.Connectcap}</td>
                                            <td>{d.total}</td>
                                         
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}
                              </table>
                              {/* end::Table */}
                          </div>
                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>              
                </div>}
                {/* end::Table 1 */}
                {/* begin::Table 2 */}
              { ReqId.data.paso1.listCloudConnIntra.length !== 0 &&
              <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Intra Region</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                          <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                             
                                      <th>Conection Type</th> 
                                      <th>Region</th>
                                      <th>Availability Zones</th>
                                      <th>Connector Size </th>                      
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {ReqId.data.paso1.listCloudConnIntra.map((d:any,i:any)=>(
                                          <tr key={i}>
                                          <td>{d.ConexionIntra}</td>
                                          <td>{d.RegionIntra}</td>
                                          <td>{d.availability}</td>
                                          <td>{d.CapacidadIntra}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 2*/}

              {/* begin::Table 2B*/}
              { ReqId.data.paso1.listCloudConnInter.length !== 0 &&
              <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Inter Region</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                          <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                             
                                      <th>Conection Type</th> 
                                        <th>Location Type</th>
                                        <th>Continet</th>
                                        <th>Zone</th>
                                        <th>Connector Size</th>                    
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {ReqId.data.paso1.listCloudConnInter.map((d:any,i:any)=>(
                                          <tr key={i}>
                                          <td>{d.ConexionInterReg}</td>
                                          <td>{d.LocacionInter}</td>
                                          <td>{d.ContinenteInterreg}</td>
                                          <td>{ d.ZonaInter}</td>
                                          <td>{d.CapacidadInterReg}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 2B*/}


                 {/* begin::Table 3 */}
               {ReqId.data.paso1.listCEdgeConn.length !== 0 &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Edge Peering Connectors</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                      <th>Network Provider</th>
                                      <th>Quantity</th>
                                      <th>Connector Size </th>                               
                                      <th>Total</th>
                                      </tr>
                                  </thead>
                                  {/* end::Table head */}


                                  {/* begin::Table body */}
                                  <tbody className='text-center'>
                                      {ReqId.data.paso1.listCEdgeConn.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.opcionEdge}</td>
                                            <td>{d.cantidadedge}</td>
                                            <td>{d.capacidadedge}</td>
                                            <td>{d.totaledge}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>
                                    {/* end::Table body */}

                              </table>
                              {/* end::Table */}
                          </div>
                        

                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 3*/}

                {/* begin::Table 4 */}
                {ReqId.data.paso1.listVRF.length !==0 &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VRF's</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                         <th>Name</th>
                                         
                                      </tr>
                                  </thead>


                                  <tbody className='text-center'>
                                      {ReqId.data.paso1.listVRF.map((d:any,i:any)=>(
                                          <tr key={i}>
                                            <td>{d.VRF_name}</td>
                                          </tr>
                                      ))
                                      }

                                  </tbody>

                              </table>
                          </div>
                        

                      </div>
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 4*/}
              { ReqId.data.paso1.Security.length !== 0 &&
              <div className='bg-light-info p-8 rounded text-center'>
                  <h4 className='text-gray-500 text-center'> Your security</h4>
                  <br />
                    <div >
                      {ReqId.data.paso1.Security.map((securidad:any,i:any)=>
                        <p key={i}> <strong className='text-info'> {securidad}</strong></p>
                      )}

                    </div>
                </div>}

                <br />

                {/* ESTO ES OUTBUND */}
                {/* begin::Table 5 */}
                {ReqId.data.paso2.llistVpnOutbund !=='' &&
                <div className='card'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Outbund per Connector</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className='table table-rounded table-striped border gy-7 gs-7 align-middle' id='table'>
                                  <thead className='fw-bold text-center'>
                                      <tr className='border-0'>
                                         <th>Name</th>
                                         
                                      </tr>
                                  </thead>


                                  <tbody id="tabla-body">
                                  </tbody>

                              </table>
                          </div>
                        

                      </div>
                      </div>
                  </div>
               
                </div>}
                {/* end::Table 5*/}



                {/* begin::Action */}
               <div className="d-flex flex-row flex-column-fluid">
                  <div className="d-flex flex-row-fluid  flex-center">
                      <button
                      type='submit'
                      id='kt_sign_in_submit'
                      className='btn btn-danger'
                      onClick={() => props?.setID(undefined)}
                    > Close</button>
                  </div>

              </div>
                

              </div>
               
               <div className='d-grid mb-10'>
                                  
               
              </div>
            </div>
            {/********************************************************************************** */}
            </div>
         </div>
      </div>
        {/* end::Modal dialog */}
    </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {ViewModalNewCTX}
